import { type LoginMethod } from "../../../components/Authentication/LoginMethods/types";

/**
 * Regional instance = deployment stack (global vs China hostname/API/CDN).
 * Not Shopify Storefront API — see StoreRegion and CountryCode for those.
 */
export enum RegionalInstanceId {
  CN = "cn",
  Global = "global",
}

export type URL_HTTPS = `https://${string}`;

export type RegionalInstanceEndpoints = {
  api: URL_HTTPS;
  cdn: URL_HTTPS;
  store: URL_HTTPS;
};

export enum RegionalInstanceCapability {
  Discord = "showDiscordUI", // NOTE: Do we need to look into if its possible that the Chinese equivalent of Discord has something we can do with roles? Or will this just stay to hide the discord UI for China
  PhoneOTP = "showPhoneOTPLogin",
  // The CN instance is Simplified Chinese only — the proxy forces `zh-CN` on
  // every request, so a language switcher there would redirect straight back.
  ChangeLocale = "canChangeLocale",
}

export type RegionalInstanceConfig = {
  [x in RegionalInstanceId]: {
    endpoints: RegionalInstanceEndpoints;
    capabilities: Record<RegionalInstanceCapability, boolean>;
    login: {
      methods: LoginMethod[];
      default: LoginMethod;
    };
  };
};
